<form *ngIf="fields && render.form" [ngClass]="{'invalid-submit': invalidSubmit}" [formGroup]="form" (submit)="save()">
  <div class="Loyalty ui-g-12 ui-md-12 ui-lg-12">
    <div class="ui-g">
      <div class="ui-g-9 ui-md-9 ui-lg-9">
        <h1 class="step-title" *ngIf="!editMode">{{ 'card_def.add_title' | translate}}</h1>
        <h1 class="step-title" *ngIf="editMode">{{ 'card_def.edit_title' | translate}}</h1>
      </div>
      <div class="ui-g-3 ui-md-3 ui-lg-3 form-button-row">
        <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" routerLink="/loyalty/card_def" label="{{ 'common.back' | translate }}"></button>
        <button pButton class="k-generic-btn" (click)="save()" type="button" icon="fa fa-floppy-o" iconPos="left" label="{{'common.save' | translate}}"></button>
      </div>
    </div>
    <div class="card">
      <div class="ui-g ui-fluid">
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.channel_id.nullable}">{{ fields.channel_id.keyName }}</span>
          <p-dropdown [options]="channels" formControlName="channel_id"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.channel_id"></app-validation-msg>
        </div>
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.cluster_id.nullable}">{{ fields.cluster_id.keyName }}</span>
          <p-dropdown [filter]="true" [options]="clusters" formControlName="cluster_id"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.cluster_id"></app-validation-msg>
        </div>
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.description.nullable}">{{ fields.description.keyName }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="description"/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.description"></app-validation-msg>
        </div>
      </div>

      <div class="ui-g ui-fluid">
        <div class="ui-g-12">
          <hr>
        </div>
      </div>

      <div class="ui-g ui-fluid">
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.card_prefix.nullable}">{{ fields.card_prefix.keyName }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="card_prefix"/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.card_prefix"></app-validation-msg>
        </div>
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.card_suffix.nullable}">{{ fields.card_suffix.keyName }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="card_suffix"/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.card_suffix"></app-validation-msg>
        </div>
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.card_lenght.nullable}">{{ fields.card_lenght.keyName }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="card_lenght"/>
          <span class="input-error-notification" *ngIf="invalidSubmit && form.controls.card_lenght.errors?.integerNotNegative">Solo caratteri numerici</span>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [arrayValidators]="[validators.integerNotNegative]" [(form)]="form" [validation]="fields.card_lenght"></app-validation-msg>
        </div>
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.range_min.nullable}">{{ fields.range_min.keyName }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="range_min"/>

          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.range_min"></app-validation-msg>
        </div>
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.range_max.nullable}">{{ fields.range_max.keyName }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="range_max"/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.range_max"></app-validation-msg>
        </div>
      </div>

      <div class="ui-g ui-fluid">
        <div class="ui-g-12">
          <hr>
        </div>
      </div>

      <div class="ui-g ui-fluid">
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.barcode_type_pid.nullable}">{{ fields.barcode_type_pid.keyName }}</span>
          <p-dropdown [options]="listTypeBarcode" formControlName="barcode_type_pid"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [arrayValidators]="[validators.integerNotNegative]" [(form)]="form" [validation]="fields.barcode_type_pid"></app-validation-msg>
        </div>
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.card_loyalty_type_pid.nullable}">{{ fields.card_loyalty_type_pid.keyName }}</span>
          <p-dropdown [options]="listTypeCard" formControlName="card_loyalty_type_pid"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [arrayValidators]="[validators.integerNotNegative]" [validation]="fields.card_loyalty_type_pid"></app-validation-msg>
        </div>
      </div>

      <div class="ui-g ui-fluid">
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.balance_type_gen.nullable}">{{ fields.balance_type_gen.keyName }}</span>
          <p-dropdown [options]="listTypeBalance" formControlName="balance_type_gen"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.balance_type_gen"></app-validation-msg>
        </div>
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.balance_type_req.nullable}">{{ fields.balance_type_req.keyName }}</span>
          <p-dropdown [options]="listTypeBalance" formControlName="balance_type_req"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.balance_type_req"></app-validation-msg>
        </div>
      </div>

      <div class="ui-g ui-fluid">
        <div class="ui-g-12">
          <hr>
        </div>
      </div>

      <div class="ui-g ui-fluid">
        <div class="ui-g-10 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.flg_std_promo_cnf.nullable}">{{ fields.flg_std_promo_cnf.keyName }}</span>
          <p-inputSwitch formControlName="flg_std_promo_cnf"></p-inputSwitch>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.flg_std_promo_cnf"></app-validation-msg>
        </div>
        <div class="ui-g-10 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.flg_point_acc.nullable}">{{ fields.flg_point_acc.keyName }}</span>
          <p-inputSwitch formControlName="flg_point_acc"></p-inputSwitch>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.flg_point_acc"></app-validation-msg>
        </div>
        <div class="ui-g-10 ui-md-4">
          <span class="label"  [ngClass]="{'required': !fields.flg_points_fru.nullable}">{{ fields.flg_points_fru.keyName }}</span>
          <p-inputSwitch formControlName="flg_points_fru"></p-inputSwitch>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.flg_points_fru"></app-validation-msg>
        </div>
      </div>
    </div>
  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-card-definition/form-card-definition-loyalty/form-card-definition-loyalty.component.html